import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/i18n.svg'


const _withScopeId = n => (_pushScopeId("data-v-71537688"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "i18n-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "i18n"
  })
], -1))
const _hoisted_4 = { class: "el-dropdown-link" }

import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

import LoginForm from '@/components/auth/LoginForm.vue';
import { ElLoading } from 'element-plus';
import moment from 'moment';
import {
  useTrack,
  FunctionIdEnum,
  EventTypeEnum,
} from '@/components/sendMetrics';
import { setLanguage, getLanguage, getMomentLanguage } from "@/components/utils/i18n";
import { setLoginFrom } from '../utils/cookies';
import Cookies from 'js-cookie';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationBar',
  setup(__props) {

const { track } = useTrack();
const { locale, t } = useI18n({ useScope: 'global' });
const router = useRouter();
const store = useStore();
const showLogin = ref(false);
const loadingInstance = ref(null);
const { VUE_APP_CARTODB_SERVER } = process.env;
const VUE_APP_IS_DDE = process.env.VUE_APP_IS_DDE == 'true';
const VUE_APP_TITLE = process.env.VUE_APP_TITLE;
const appCode = process.env.VUE_APP_OAUTH_APPCODE;
const VUE_APP_APP_TYPE = process.env.VUE_APP_APP_TYPE;
const VUE_APP_IS_GEOVISEARTH = VUE_APP_APP_TYPE == 'geovisearth';
const AUTH_MODE = process.env.VUE_APP_AUTH_MODE || (VUE_APP_IS_DDE ? 'dde' : (VUE_APP_IS_GEOVISEARTH ? 'geovisearth' : 'mapscloud'));

const savedLocale = getLanguage();
if (savedLocale) {
  locale.value = savedLocale;
}
moment.locale(getMomentLanguage(savedLocale));
const menuItems = computed(() => [
  {
    key: '1',
    name: t('navigation.home'),
    icon: '',
    handler: () => { 
      track(FunctionIdEnum.globalLayer_header_showHome, EventTypeEnum.CLICK);
      router.push({ name: 'home' }) 
    },
  },
  {
    key: 'Atlas',
    name: t('navigation.atlas'),
    icon: '',
    handler: () => {
      track(FunctionIdEnum.globalLayer_header_showGallery, EventTypeEnum.CLICK);
      window.location.href = `${VUE_APP_CARTODB_SERVER}/explore?locale=${locale.value}`;
    },
  },
]);

const cartoAuthed = computed(() => {
  if (AUTH_MODE === 'dde') {
    const accountName = localStorage.getItem('accountName');
    return accountName
  } else {
    return store.state.auth.cartoConfig;
  }
});
const cartoUserCreationState = computed(
  () => store.state.auth.cartoUserCreationState,
);
const username = computed(() => {
  if (AUTH_MODE === 'dde') {
    return cartoAuthed.value;
  } else {
    return cartoAuthed.value?.user_data?.username;
  }
});

const handleLocaleChange = (command: string | number | object) => {
  track(FunctionIdEnum.globalLayer_header_switchLanguage, EventTypeEnum.CLICK);

  locale.value = command;
  setLanguage(locale.value);
  moment.locale(
    getMomentLanguage(savedLocale)
  );
};

const goToMapping = () => {
  track(FunctionIdEnum.globalLayer_header_createMap, EventTypeEnum.CLICK);
  const url = AUTH_MODE === 'carto'
    ? `${VUE_APP_CARTODB_SERVER}/login?return_to=${encodeURIComponent(VUE_APP_CARTODB_SERVER)}`
    : (AUTH_MODE === 'dde' ? VUE_APP_CARTODB_SERVER : `${VUE_APP_CARTODB_SERVER}/autologin`);
  window.open(url, '_blank');
};

function toLogin() {
  track(FunctionIdEnum.globalLayer_header_login, EventTypeEnum.CLICK);

  if (AUTH_MODE === 'dde') {
    window.location.href =
      `https://user-oneid.deep-time.org/ngiam-rst/v1/sdk/login/sso?appCode=${appCode}`;
  } else if (AUTH_MODE === 'geovisearth') {
    setLoginFrom();
    window.location.href = `${VUE_APP_CARTODB_SERVER}/geovisearth-oauth2/login`;
  } else if (AUTH_MODE === 'carto') {
    const returnTo = window.location.href;
    window.location.href = `${VUE_APP_CARTODB_SERVER}/login?return_to=${encodeURIComponent(returnTo)}`;
  } else {
    showLogin.value = true;
  }
}
async function logout() {
  if (AUTH_MODE === 'carto') {
    try {
      await fetch(`${VUE_APP_CARTODB_SERVER}/logout`, {
        method: 'GET',
        credentials: 'include',
        mode: 'no-cors',
      });
    } finally {
      await store.dispatch('auth/logout');
      window.location.reload();
    }
  } else if (AUTH_MODE === 'geovisearth') {
    const baseURL = Cookies.get('_cartodb_new_base_url') || VUE_APP_CARTODB_SERVER;
    try {
      await fetch(`${baseURL}/logout`, {
        method: 'GET',
        credentials: 'include',
        mode: 'no-cors',
      });
    } finally {
      store.dispatch('auth/logout');
      window.location.reload();
    }
  } else if (AUTH_MODE === 'dde') {
    store.dispatch('auth/logout');
    window.location.href =
      `https://user-oneid.deep-time.org/ngiam-rst/cas/logout?context=${encodeURIComponent(window.location.href)}`
  } else {
    await store.dispatch('auth/logout');
    window.location.reload();
  }
}
watch(cartoAuthed, (newVal, _) => {
  if (newVal) {
    showLogin.value = false;
  }
});
watch(cartoUserCreationState, (newVal, _) => {
  if (newVal === 'processing') {
    loadingInstance.value = ElLoading.service({
      body: true,
      text: t('navigation.creatting_cartodb_user'),
    });
  } else {
    loadingInstance.value && loadingInstance.value.close();
  }
});


return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_text, {
        style: {"color":"white"},
        size: "large",
        if: "!VUE_APP_IS_DDE"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(VUE_APP_TITLE)), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_menu, {
        "background-color": "#000",
        "text-color": "#fff",
        mode: "horizontal",
        "default-active": "1",
        index: "Home"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (menu) => {
            return (_openBlock(), _createBlock(_component_el_menu_item, {
              key: menu.key,
              index: menu.key
            }, {
              default: _withCtx(() => [
                (menu.href)
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      underline: false,
                      href: menu.href,
                      target: "_blank",
                      class: "menu-name"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(menu.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["href"]))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "menu-name",
                      onClick: menu.handler
                    }, _toDisplayString(menu.name), 9, _hoisted_2))
              ]),
              _: 2
            }, 1032, ["index"]))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_el_space, { spacer: 5 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            size: "small",
            type: "primary",
            onClick: goToMapping
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('navigation.mapping')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_dropdown, {
            trigger: "click",
            onCommand: handleLocaleChange
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_dropdown_item, { command: "en" }, {
                    default: _withCtx(() => [
                      _createTextVNode("English")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_dropdown_item, { command: "zh" }, {
                    default: _withCtx(() => [
                      _createTextVNode("中文")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          (!cartoAuthed.value)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                link: "",
                class: "auth-btn",
                onClick: toLogin
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('login.title')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (cartoAuthed.value)
            ? (_openBlock(), _createBlock(_component_el_dropdown, { key: 1 }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, { onClick: logout }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('login.logout')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_4, [
                    _createTextVNode(_toDisplayString(username.value) + " ", 1),
                    _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_arrow_down)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: showLogin.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showLogin).value = $event)),
      "destroy-on-close": "",
      style: {"max-width":"700px"},
      class: "login-dialog"
    }, {
      default: _withCtx(() => [
        _createVNode(LoginForm)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})